import type { FC, SVGProps } from 'react'
import { Button } from './ui/button'
import { Plus } from './icons'

interface EmptyStateProps {
  icon: FC<SVGProps<SVGSVGElement>>
  title: string
  description: string
  addButtonText?: string
  onAdd?: () => void
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  addButtonText,
  onAdd,
}: EmptyStateProps) {
  return (
    <div className="flex flex-1 items-center justify-center">
    <div className="rounded-lg border border-border-L2 bg-surface-L2 p-8 w-full">
      <div className="flex flex-col items-center gap-4">
        <div className="flex items-center justify-center rounded-lg bg-background-brand-secondary-subtle p-2">
          <Icon className="size-4 text-content-brand-bold" />
        </div>
        <div className="flex flex-col gap-1 text-center">
          <p className="text-base font-semibold text-content-primary-bold tracking-tight">
            {title}
          </p>
          <p className="text-sm text-content-primary-subtle">{description}</p>
        </div>
        {addButtonText && onAdd && (
          <Button variant="primary" size="sm" onClick={onAdd}>
            <Plus className="size-3.5" />
            {addButtonText}
          </Button>
        )}
      </div>
    </div>
    </div>
  )
}
